import {Component, inject, Inject, model} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent, MatDialogRef,
  MatDialogTitle
} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";

@Component({
  selector: 'wun-prompt-dialog',
  standalone: true,
  imports: [
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ],
  templateUrl: './prompt-dialog.component.html',
  styleUrl: './prompt-dialog.component.scss'
})
export class PromptDialogComponent {
  readonly dialogRef = inject(MatDialogRef<PromptDialogComponent>);
  readonly data = inject<{title: string, question: string}>(MAT_DIALOG_DATA);
  readonly title = model(this.data.title);
  readonly question = model(this.data.question);

  onNoClick(): void {
    this.dialogRef.close({
      delete: false
    });
  }

  onOkCLick() {
    this.dialogRef.close({
      delete: true
    });
  }
}
